import React, {useEffect, useState} from 'react';
import styles from './index.module.less';
import CodingEditor from "./PythoinCodeEditor";
import ArticleReader from "./ArticleReader";
import useChapter from "../../components/useChapter";
import Tour from 'reactour';
import tourSteps from '../../utils/tour-steps';
import DocumentTitle from 'react-document-title';
import {useParams} from 'react-router-dom';

const Lesson = () => {
  const { lesson, setLesson } = useChapter();
  const [showTour, setShowTour] = useState(false);
  const { chapterName } = useParams();
  useEffect(() => {
    const showed = window.localStorage.getItem('lesson-tour-showed');
    if (!showed) {
      setShowTour(true);
    }
  }, []);
  const handleTourClosed = () => {
    window.localStorage.setItem('lesson-tour-showed', '1');
    setShowTour(false);
  };
  return (
    <DocumentTitle title={`${chapterName} - Python for Fun`}>
      <div className={styles.home}>
        <div className={styles.left}>
          <ArticleReader lesson={lesson} setLesson={setLesson} />
        </div>
        <div className={styles.right}>
          <CodingEditor lesson={lesson} setLesson={setLesson}/>
        </div>
        <Tour isOpen={showTour} steps={tourSteps.lesson} onRequestClose={handleTourClosed} />
      </div>
    </DocumentTitle>
  );
};

export default Lesson;
